import React, { useState, useEffect } from "react"
import { graphql } from "gatsby";
import Layout from "../../components/Layout"
import { SmallBar } from "../../components/PageEnd/PageEnd"
import MainPageHeader from "../../components/MainPageHeader/MainPageHeader"
import MainPageIntro from "../../components/MainPageIntro/MainPageIntro";
import BlogBlock from "../../components/BlogBlock/BlogBlock";
import MetaHead from "../../components/MetaHead";

const BlogPage = ({data}) => {

  const [filterValues, setFilterValues] = useState({
      author: 0,
      postType: 0,
    });

  useEffect(() => {
    const url = new URL(window.location);
    const authorParam = url.searchParams.get('author');
    const postTypeParam = url.searchParams.get('postType');
    setFilterValues({
        author: authorParam ? parseInt(authorParam) : 0,
        postType: postTypeParam ? postTypeParam : 0,
    });

  }, []);

  function handleFilterChange(filter, value) {
    const newFilterValues = {...filterValues};
    newFilterValues[filter] = value;
    setFilterValues(newFilterValues);
    const url = new URL(window.location);
    if (value && value !== 0) {
      url.searchParams.set(filter, value);
    } else {
      url.searchParams.delete(filter)
    }
    window.history.pushState(null, '', url.toString());
  }

  return (
      <Layout>
        <MainPageHeader 
          title={data.page.Title} 
          image={data.page.HeroImage.url} 
          gatsbyImage={data?.page?.HeroImage?.localFile?.childImageSharp?.gatsbyImageData}
          accentColour={data.page.AccentColour}
          backLabel={'Community'}
          backLink={'/community'}
        />
        <MainPageIntro 
          title={data?.page?.IntroTitle}
          introText={data?.page?.IntroText?.data?.IntroText}
          introImage={data?.page?.IntroImage?.url}
          introGatsbyImage={data?.page?.IntroImage?.localFile?.childImageSharp?.gatsbyImageData}
          accentColour={data?.page?.AccentColour}
          ctaLabel={data?.page?.CTALabel}
          ctaLink={data?.page?.CTALink}
          tintOverlay={'overlay'}
        /> 
        <BlogBlock filterValues={filterValues} filterChange={(filter, value) => handleFilterChange(filter, value)}/>
        <SmallBar />
      </Layout>
  )
}

export default BlogPage;

export const Head = ({data}) => <MetaHead
                                  title={'The Information Lab - Blog'}
                                  description={"For over a decade, The Information Lab blog has been your go-to source for Tableau, Alteryx, and data-related content. Join us as we continue to explore, innovate, and share our passion for all things data."}
                                  image={data?.page?.IntroImage?.url}
                                />

export const query = graphql`
  query ServicesQuery {
  page: strapiTilWwwPage(slug: {eq: "blog"}) {
    Title
    IntroTitle
    AccentColour
    HeroImage {
      url
      localFile {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, formats: WEBP)
        }
      }
    }
    IntroImage {
      url
      localFile {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, formats: WEBP)
        }
      }
    }
    IntroText {
      data {
        IntroText
      }
    }
    CTALabel
    CTALink
  }
}
`
